export const groupBy = function (data: Array<any>, hasher: (item: any) => string) {
    return data?.reduce(function (rv, x) {
        const key = hasher(x)
        rv[key] = (rv[key] || [])
        rv[key].push(x);
        return rv;
    }, {});
};